import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { toast } from "sonner";
import { getCookie, setCookie } from "../../context/useCookies";
import { resolveOrderNavigation } from "../../Redux/orderSlice";
import Loader from "../../components/Loader/Loader";

const OrderNavigation = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { redisKey } = useParams();

    useEffect(() => {

        if (!redisKey) {
            toast.error("Invalid navigation link");
            navigate("/");
            return;
        }

        const handleNavigation = async () => {

            try {

                const existingSession =
                    JSON.parse(
                        getCookie("eyisionAdmin") || "null"
                    );

                const payload = {
                    redisKey,
                };

                if (existingSession?.userId) {

                    payload.currentUserId =
                        existingSession.userId;

                    payload.currentStoreId =
                        existingSession.storeId;
                }

                const response = await dispatch(
                    resolveOrderNavigation(payload)
                ).unwrap();

                console.log("response_____response", response);
                const responseData = response?.data;


                if (responseData?.requiresLogin) {

                    setCookie(
                        "eyisionAdmin",
                        JSON.stringify({
                            userId:
                                responseData?.user?.userId,

                            roleId:
                                responseData?.user?.roleId,

                            name:
                                responseData?.user?.name,

                            email:
                                responseData?.user?.email,

                            token:
                                responseData?.token,

                            refreshToken:
                                responseData?.refreshToken,

                            role:
                                responseData?.user?.role,

                            storeId:
                                responseData?.user?.storeId,
                        })
                    );
                    setCookie("accessToken", responseData?.token);

                }

                setTimeout(() => {
                    navigate(
                        `/${responseData?.redirectLink}`
                    );
                }, 2000);

            } catch (error) {

                console.error(error);

                toast.error(
                    error?.message ||
                    "Navigation failed"
                );

                navigate("/login");

            }
        };

        handleNavigation();

    }, [dispatch, navigate, redisKey]);

    return (
        <div className="w-full h-screen flex items-center justify-center bg-[#d7becf]">
            <Loader loading={true} />
        </div>
    );
};

export default OrderNavigation;